// extracted by mini-css-extract-plugin
module.exports = {"root":"menu-item-content_root__7_yew","check":"menu-item-content_check__9SJwU","checkIcon":"menu-item-content_checkIcon__8HMNG"};